import { useTranslation } from "react-i18next";
import {React, useEffect, useState} from "react";
import {
    BUTTON,
    POLL_SHARE_MODE, POLL_TYPE,
} from "../../utils/constants";
import classes from "./ReleaseActivityPage.module.css";
import {convertPercentage} from "../../utils/helpers";

import { ReactComponent as GRADIENT_IMG } from "./images/total_participants_gradient_img.svg";


export default function ViewMetricCardParticipants({
                                                       data=[],
                                                       dataAll={},
                                                       pollData=[],
                                                       curQuestionNo,
}) {
    const { t } = useTranslation();
    // const location = useLocation();
    const {poll={}, questions=[]} = pollData;


    const [cardCollapsed, setCardCollapsed] = useState(false); // !location?.state?.expandedAnalytics
    const [chartData, setChartData] = useState({});

    const COLOR_SECTION = {COMPLETE: "#0B7E0F", IN_PROGRESS: "#3663CA"}

    useEffect(() => {

        if ([POLL_SHARE_MODE.SHARE_ALL, POLL_SHARE_MODE.SCHEDULE].includes(poll?.pollShareMode)) {
            setChartData(dataAll);
        } else {
            if (!!data && data.length > 0 && data.length >= curQuestionNo) {
                setChartData(data[curQuestionNo - 1]);
            } else {
                setChartData({});
            }
        }

    }, [data, dataAll, pollData, curQuestionNo]);

    useEffect( () => {
        if (Object.entries(chartData).length === 0 || !chartData.total) {
            if(document.getElementById("inProgressBar") !== null) {
                document.getElementById("inProgressBar").style.width = "0";
            }

            if(document.getElementById("completionBar") !== null) {
                document.getElementById("completionBar").style.width = "0";
            }
            return;
        }


        if(document.getElementById("inProgressBar") !== null) {
            let width = chartData.unattempted * 100 / chartData.total;
            document.getElementById("inProgressBar").style.width = width + "%";
        }
        if(document.getElementById("completionBar") !== null) {
            let width = chartData.attempted * 100 /chartData.total;
            document.getElementById("completionBar").style.width = width + "%";
        }
    }, [chartData, cardCollapsed]);

    let isShareAll = [POLL_SHARE_MODE.SHARE_ALL, POLL_SHARE_MODE.SCHEDULE].includes(poll?.pollShareMode);

    return(
        <div className={classes.metricCard} style={{maxHeight: cardCollapsed ? 50 : 500}}>
            <h2 className={classes.metricCardHeader}>
                <div className={classes.metricCardHeaderTitle}>
                    {isShareAll
                        ? t("poll.livePollAnalytics")
                        : poll.pollType !== POLL_TYPE.ATTENDANCE ? t("poll.liveAnalyticsQuestion", {number: curQuestionNo}) : t("poll.liveAnalytics")
                    }
                </div>
                <span
                    tabIndex={0}
                    role={BUTTON}
                    aria-expanded={cardCollapsed ? "false" : "true"}
                    aria-controls={"participant-card-body"}
                    aria-label={cardCollapsed ? t("accessibility.expandMetricsCard") : t("accessibility.collapseMetricsCard")}
                    className={classes.metricCardControlBtn}
                    onClick={() => setCardCollapsed(!cardCollapsed)}
                >
                    {cardCollapsed ? t("common.viewAll") : t("poll.viewLess")}
                </span>

            </h2>

            <div id={"participant-card-body"} className={classes.metricCardBody} style={{visibility: cardCollapsed ? "hidden" :"visible"}}>

                <div className={`${classes.metricCardTotalParticipantsContainer} ${classes.row}`}>
                    <GRADIENT_IMG style={{position: "absolute", top: 0, left: 0}}/>
                    <div
                        className={classes.row}
                        style={{position: "absolute", top: 0, left: 0, height: "100%", width: "100%"}}
                    >
                        <div style={{width: 21}}/>
                        <span className={classes.metricCardGradientTotalParticipantsPartA}>
                            {chartData.total}
                        </span>
                        <div style={{width: 15}}/>
                        <span className={classes.metricCardGradientTotalParticipantsPartB}>{t("report.participantMetricTitle")}</span>

                    </div>
                </div>


                <div className={classes.column}>
                    <span className={classes.metricCardDescription}>{t("poll.completion")}</span>
                    <div style={{height: 4}}/>
                    <div className={classes.row}>
                        <span
                            className={classes.metricCardLabel}>{convertPercentage(chartData.attempted, chartData.total)}</span>
                        <span style={{flex: 1}}/>
                        <span
                            className={classes.metricCardCountText}
                            style={{color: COLOR_SECTION.COMPLETE}}
                        >{t("poll.completeRatio", {done: chartData.attempted, total: chartData.total})}</span>
                    </div>
                    <div style={{height: 10}}/>
                    <div className={classes.metricCardCountBarContainer}>
                        <div id="completionBar" className={classes.metricCardCountBar} style={{background: COLOR_SECTION.COMPLETE}}>.</div>
                    </div>

                    <div style={{height: 15}}/>


                    <span className={classes.metricCardDescription}>{t("common.inProgress")}</span>
                    <div style={{height: 4}}/>
                    <div className={classes.row}>
                        <span
                            className={classes.metricCardLabel}>{convertPercentage(chartData.unattempted, chartData.total)}</span>
                        <span style={{flex: 1}}/>
                        <span
                            className={classes.metricCardCountText}
                            style={{color: COLOR_SECTION.IN_PROGRESS}}
                        >{t("poll.inProgressRatio", {done: chartData.unattempted, total: chartData.total})}</span>
                    </div>
                    <div style={{height: 10}}/>
                    <div className={classes.metricCardCountBarContainer}>
                        <div id="inProgressBar" className={classes.metricCardCountBar} style={{background: COLOR_SECTION.IN_PROGRESS}}>.</div>
                    </div>
                    <div style={{height: 10}}/>
                </div>
            </div>
        </div>
    );
}
